<app-modal *ngIf="vo$ | async; let vo" class="consumer-mapping-popup">
	<div modal-body class="consumer-mapping-popup__body">
		<div class="consumer-mapping-popup__info">
			<div class="info">
				<mat-icon [svgIcon]="DcIcons.Details"></mat-icon>
				<span i18n="@@expositions.consumers.mapping.popup.details">details</span>
			</div>
		</div>

		<div
			class="consumer-mapping-popup__selected-members"
			[class.no-selection]="vo.selectedConsumers.length === 0">
			<div
				*ngIf="vo.selectedConsumers.length !== 0"
				class="consumer-selection-chips">
				<app-chip
					*ngFor="let item of vo.selectedConsumers"
					viewMode="default"
					(remove)="removeSelectedConsumer(item.id)">
					<mat-icon
						*ngIf="item.isGroup"
						[svgIcon]="DcIcons.Group"
						app-chip-icon></mat-icon>
					<app-avatar
						*ngIf="!item.isGroup && item.avatar"
						[avatar]="item.avatar"
						app-chip-icon></app-avatar>

					<span>{{ item.name }}</span>
				</app-chip>
			</div>
			<div
				*ngIf="vo.selectedConsumers.length === 0"
				class="consumer-selection-area">
				<span i18n="@@expositions.consumers.mapping.popup.no-selection">
					no-selection
				</span>
			</div>
		</div>

		<div class="consumer-mapping-popup__members">
			<app-toggle-buttons [actions]="consumerTypes"></app-toggle-buttons>
			<app-panel
				headerHeight="3.25rem"
				isAlwaysOpen="true"
				hasSearchableGrid="true"
				hasRefresh="true"
				maxActionsCount="6"
				[itemsCount]="vo.consumerList.totalItemsCount"
				(refresh)="refresh()"
				(search)="search($event)">
				<div
					*ngIf="consumerType$ | async; let consumerType"
					panel-title
					class="app-panel__title">
					<ng-container *ngIf="consumerType === ConsumerType.User">
						<mat-icon [svgIcon]="DcIcons.User"></mat-icon>
						<span i18n="@@general.memberType.users">users</span>
					</ng-container>

					<ng-container *ngIf="consumerType === ConsumerType.Group">
						<mat-icon [svgIcon]="DcIcons.Group"></mat-icon>
						<span i18n="@@general.memberType.groups">groups</span>
					</ng-container>
				</div>
				<app-member-list
					[memberList]="vo.consumerList"
					[initialSelectedMembers]="vo.initialSelectedConsumers"
					(optionChanged)="onOptionChange($event)"
					(selectItems)="selectTargetConsumers($event)"></app-member-list>
			</app-panel>
		</div>
	</div>
	<div modal-footer class="consumer-mapping-popup__footer">
		<button
			id="{{ cmpId }}-delete-btn"
			class="consumer-mapping-popup__footer__btn"
			[color]="'primary'"
			[disabled]="vo.selectedConsumers.length === 0"
			(click)="saveAction()"
			mat-raised-button>
			<span i18n="@@general.action.save">save</span>
		</button>
	</div>
</app-modal>
